/*
 * Fixed position footer
 * ----------------------------------------------- */
(function ($) {
  "use strict";

  $(".faq-item").on("click", function () {
    $(this).toggleClass("is-open");
    $(this).children("dd").slideToggle(200);
  });
})(jQuery);
